module.exports = __webpack_public_path__ + "static/media/alert-icon.8325721f.svg";